import api from 'api';

export const loadBusinessPartners = api(
  'GET /api/io/business-entities/business-partners'
);

export const loadBusinessPartnerVersion = api(
  'GET /api/io/business-entities/business-partners/:businessPartnerId/versions'
);
export const loadBusinessEntityDetails = api(
  'GET /api/io/business-entities/details'
);
export const loadUsersSuggestions = api('GET /api/users-suggestions');
